/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import Cleave from 'cleave.js/react';

class InputFilter extends React.Component{
    onChange(event) {
        this.props.onChange({name: this.props.name, filter_field: this.props.filter_field, value: event.target.value})
    }
    showLabel(name_postfix) {
        if (this.props.label) {
            return (
                <label htmlFor={name_postfix}>{this.props.label}</label>
            )
        } else {
            return null;
        }
    }
    render() {
        let value = (this.props.value) ? this.props.value : '';
        let autofocus = (this.props.autofocus) ? true : '';
        let name_postfix = (this.props.postfix) ? this.props.name + '_' + this.props.postfix : this.props.name + '_filter';
        let wrap_className = "input filter field_wrap " + name_postfix;
        if (this.props.input_control) {
            return (
                <div className={wrap_className}>
                    {this.showLabel(name_postfix)}
                    <Cleave id={name_postfix} name={name_postfix} type={this.props.type} value={value} autoComplete="off"
                            placeholder={this.props.placeholder}
                            options={this.props.input_control}
                            onChange={this.onChange.bind(this)}
                    />
                </div>
            )
        } else {
            return (
                <div className={wrap_className}>
                    {this.showLabel(name_postfix)}
                    <input autoFocus={autofocus} id={name_postfix} name={name_postfix}
                           placeholder={this.props.placeholder}
                           type={this.props.type}
                           onChange={this.onChange.bind(this)}
                           value={value} autoComplete="off"
                    />
                </div>
            )
        }

    }
}

export default InputFilter;